module.exports = __webpack_public_path__ + "static/media/red-circle-remove.0a0c1638.svg";